
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#757F8A","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M5.796 13.055c.239 0 .438-.08.598-.24L10.595 8.7c.113-.11.195-.22.246-.334a.892.892 0 00.076-.369 1.012 1.012 0 00-.079-.375.992.992 0 00-.243-.328L6.394 3.188a.811.811 0 00-.598-.24.852.852 0 00-.436.114.876.876 0 00-.314.307.851.851 0 00.158 1.06l3.68 3.569-3.68 3.563a.89.89 0 00-.275.638.862.862 0 00.867.855z"}}),_c('path',{attrs:{"d":"M11.796 13.055c.239 0 .438-.08.598-.24L16.595 8.7c.113-.11.195-.22.246-.334a.892.892 0 00.076-.369 1.012 1.012 0 00-.079-.375.992.992 0 00-.243-.328l-4.201-4.107a.811.811 0 00-.598-.24.852.852 0 00-.436.114.876.876 0 00-.314.307.851.851 0 00.158 1.06l3.68 3.569-3.68 3.563a.89.89 0 00-.275.638.862.862 0 00.867.855z"}})])])
          )
        }
      }
    